import { Download } from "lucide-react";
import { API, BACKEND_URL } from "@/lib/api";

const STEPS = [
  "Pobierz projekt (config.json ma już wpisany adres Twojego API).",
  "Zainstaluj .NET 8 SDK na Windows.",
  "dotnet publish -c Release -r win-x64 -p:PublishSingleFile=true --self-contained false",
  "Skopiuj Metin2Patcher.exe i config.json do folderu klienta gry.",
  "Wgrywaj pliki w zakładce „Pliki patcha” - gracze dostaną je przy następnym uruchomieniu.",
];

export default function ClientDownload() {
  const href = `${API}/client/source.zip?base_url=${encodeURIComponent(BACKEND_URL)}`;
  return (
    <div className="grid lg:grid-cols-2 gap-12">
      <div>
        <h2 className="font-display text-2xl text-amber-100">Klient C# (WinForms + WebView2)</h2>
        <p className="text-sm text-slate-500 mt-2 max-w-md">Okno bez ramki wyświetla launcher webowy, porównuje sumy SHA-256 lokalnych plików z manifestem i pobiera tylko zmienione pliki.</p>
        <a href={href} className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-amber-500 text-white font-bold rounded hover:bg-amber-400 transition-colors" data-testid="client-download-btn">
          <Download size={18} /> Pobierz Metin2Patcher.zip
        </a>
        <div className="mt-8 space-y-1 text-xs font-mono text-slate-500">
          <div>Manifest: <span className="text-amber-300/80" data-testid="client-manifest-url">{API}/patch/manifest</span></div>
          <div>Launcher: <span className="text-amber-300/80">{BACKEND_URL}/launcher</span></div>
        </div>
      </div>
      <ol className="space-y-4">
        {STEPS.map((s, i) => (
          <li key={s} className="flex gap-4">
            <span className="font-display text-amber-500 text-lg w-6">{i + 1}</span>
            <span className={`text-sm ${s.startsWith("dotnet") ? "font-mono text-amber-200 bg-black/50 px-2 py-1 rounded" : "text-slate-300"}`}>{s}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
